import styled from 'styled-components';
import { ToastContainer, toast } from 'react-toastify';
import React from 'react';
import Toast from './Toast';

const Container = styled(ToastContainer)`
  & {
    bottom: 0;
    padding: 0;
    width: 100%;
    position: fixed;
    box-sizing: border-box;
    left: 0;
    right: 0;
    margin: 0;
    display: flex;
    flex-direction: row;
    justify-content: center;
  }
  .Toastify__toast {
   background: ${(props) => props.theme.colours.alert};
    margin: 0;
  //  padding: ${(props) => props.theme.whitespace.base};
    max-width: ${(props) => props.theme.misc.appWidth};
    width: 100%;
  }
  .Toastify__progress-bar {
    background: ${(props) => props.theme.colours.accent};
    height: 3px;
  }
`;

class ToastFactory {
  constructor(){
    this.errorToastId = undefined;
    this.infoToastId = undefined;
    this.id = Math.round(Math.random()*1000)
  }
  getEl(title, body){
    this.el = (<Toast primary={title} secondary={body} />);
    return this.el;
  }
  error(title, body, options){
    const el = this.getEl(title, body);
    options = {
      ...options,
      onClose : () => {
        this.errorToastId = undefined;
      },
      type: toast.TYPE.ERROR,
      autoClose: false,
      closeButton: true,
      position: 'bottom-center'
    }

    if(this.infoToastId){
      toast.dismiss(this.infoToastId);
      this.infoToastId = undefined;
      return setTimeout(()=>{
        this.error(title, body, options)
      }, 1000);
    }
    if(!this.errorToastId){
      this.errorToastId = toast(el, options);
      return this.errorToastId;
    }
    return null;
  }
  info(title, body, options = {}){

    const el = this.getEl(title, body);
    if(this.errorToastId) {
      toast.dismiss(this.errorToastId);
      this.errorToastId = undefined;
      return setTimeout(()=>{
        this.info(title, body, options)
      }, 1000);
    }
    options = {
      ...options,
      onClose : () => {
        this.infoToastId = undefined;
      },
      type : toast.TYPE.INFO,
      autoClose : 4000,
      closeButton : false,
      position: 'bottom-center'
    }
    if(this.infoToastId){
      return toast.update(this.infoToastId, options);
    }
    this.infoToastId = toast(el, options);
    return this.infoToastId
  }
}

const toastFactory = new ToastFactory();

export { Container as ToastContainer, toastFactory as toast };
